import type { DocumentRole } from "./api";

// "anonymous" sits below all member roles — it represents a non-member
// caller viewing a public doc. Any roleAtLeast() check against a real role
// returns false for anonymous.
const ROLE_AUTHORITY: Record<DocumentRole, number> = {
  anonymous: -1,
  viewer: 0,
  commenter: 1,
  editor: 2,
  maintainer: 3,
  owner: 4,
};

export function roleAtLeast(actual: DocumentRole, threshold: DocumentRole): boolean {
  return ROLE_AUTHORITY[actual] >= ROLE_AUTHORITY[threshold];
}
